import "./forgotpassword.css";
import "./login.css";
import { Card, Form, Button, InputGroup } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { useState, useEffect } from "react";
import { ConfigProvider, Input } from "antd";
import Eye from "../../assets/Eye.svg";
import EyeOff from "../../assets/Eyeoff.svg";
import { checkEmailApi, verifyOtpApi, forgotPasswordApi, getAppSettings } from "../../api/api";
import { useNavigate } from "react-router-dom";
import { handleError } from "../../helpers/handleError";
import SpinLoading from "../../components/spinLoading/SpinLoading";
import brandLogo from "../../assets/image/logo.e3c0b2196cc23f84f67a.png";


const ForgotPassword = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    watch,
  } = useForm();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [email, setEmail] = useState("");
  const [checkemailError, setCheckemailError] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [isPassword, setIsPassword] = useState(false);
  const [otp, setOtp] = useState("");
  const [otpError, setOtpError] = useState("");
  const [timeLeft, setTimeLeft] = useState(60);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [appSettings, setAppSettings] = useState({});

  useEffect(() => {
    if (timeLeft === 0) return;

    const timerId = setInterval(() => {
      setTimeLeft((prevTime) => prevTime - 1);
    }, 1000);

    return () => clearInterval(timerId); // Cleanup the interval on unmount or when timer reaches 0
  }, [timeLeft]);
  const onSubmit = async (data) => {
    try {
      setIsLoading(true);
      const response = await checkEmailApi(data);
      if (response.status === 200) {
        setIsOpen(true);
        setIsPassword(false);
        setEmail(data.email);
        setTimeLeft(60);
      } else {
        setCheckemailError(response?.data?.message || "Algo salió mal");
      }
    } catch (error) {
      console.error(error);
      setCheckemailError(error?.response?.data?.message || "Algo salió mal");
    } finally {
      setIsLoading(false);
    }
  };
  const submitOtp = async () => {
    if (otp === "") {
      setOtpError("El código OTP es obligatorio");
      return;
    }
    if (otp.length !== 4) {
      setOtpError("El código OTP debe tener 4 dígitos");
      return;
    }
    try {
      setIsLoading(true);
      const response = await verifyOtpApi({ email: email, otp: otp });

      if (response.status === 200) {
        setIsOpen(false);
        setIsPassword(true);
        setTimeLeft(60);
      } else {
        setOtpError(response?.data?.message || "Algo salió mal");
      }
    } catch (error) {
      console.error(error);
      setOtpError(error?.response?.data?.message || "Algo salió mal");
    } finally {
      setIsLoading(false);
    }
  };
  const resendOtp = async () => {
    try {
      setIsLoading(true);
      const response = await checkEmailApi({ email: email });
      if (response.status === 200) {
        setTimeLeft(60);
        setOtpError("");
      } else {
        setOtpError(response?.data?.message || "Algo salió mal");
      }
    } catch (error) {
      console.error(error);
      setOtpError(error?.response?.data?.message || "Algo salió mal");
    } finally {
      setIsLoading(false);
    }
  };

  const onSubmitPassword = async (data) => {
    try {
      setIsLoading(true);
      const response = await forgotPasswordApi({
        email: email,
        password: data.password,
        confpassword: data.confirmPassword,
        otp: otp,
      });
      if (response.status === 200) {
        setIsOpen(false);
        setIsPassword(false);
        setEmail("");
        setOtp("");
        setOtpError("");
        setCheckemailError("");
        setIsLoading(false);
        navigate("/login");
      } else {
        setOtpError(response?.data?.message || "Something went wrong");
      }
    } catch (error) {
      handleError(error);
      setOtpError(error?.response?.data?.message || "Something went wrong");
    } finally {
      setIsLoading(false);
    }
  };

  const onChange = (text) => {
    if (!/^\d*$/.test(text)) {
      setOtpError("OTP must be a number");
    } else {
      setOtpError("");
      setOtp(text);
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    (async () => {
      try {
        const res = await getAppSettings();
        if (res.status === 200) setAppSettings(res.data.info || {});
      } catch {}
    })();
  }, []);
  
  if (isLoading) return <SpinLoading />;
  /*
        <Header imageSrc={image} title="OlvidÃ© mi contraseÃ±a" navigation={nav} />
        <div className="forgotpassword-container pading150">
          <Card className="forgotpassword-card">
            <Card.Body style={{ padding: "0px" }}>
              <Skeleton active title={{ width: "60%" }} paragraph={{ rows: 2, width: "80%" }} />
              <div className="mt-3">
                {Array.from({ length: 2 }).map((_, i) => (
                  <div key={i} className="mb-3">
                    <Skeleton.Input active block style={{ height: 44 }} />
                  </div>
                ))}
                <Skeleton.Button active block style={{ height: 44 }} />
              </div>
            </Card.Body>
          </Card>
        </div>
      </>
    */
  return (
    <>
      <div className="login-container forgotpassword-container pading150">
        <div className="login-logo-wrap">
          <img
            className="login-logo"
            src={appSettings.logo || brandLogo}
            alt="Zoco"
            style={{ cursor: "pointer" }}
            onClick={() => navigate("/event")}
          />
        </div>
        {!isOpen && !isPassword && (
          <Card className="login-card forgotpassword-card">
            <Card.Body style={{ padding: "0px" }}>
              <h2 className="login-title">¿Olvidaste tu contraseña?</h2>
              <p className="login-subtitle">Ingresa tu correo para restablecer tu contraseña.</p>
              {checkemailError && (
                <div className="login-alert" style={{ marginBottom: 16 }}>
                  <span className="icon" style={{ color: "#E53935" }}>i</span>
                  <div>{checkemailError}</div>
                </div>
              )}
              <Form onSubmit={handleSubmit(onSubmit)}>
                <Form.Group className="mb-4">
                  <Form.Control
                    type="email"
                    placeholder="Correo electrónico*"
                    {...register("email", { required: "El correo electrónico es obligatorio" })}
                    className="login-input"
                  />
                  {errors.email && <p className="field-error">{errors.email.message}</p>}
                </Form.Group>
                <Button type="submit" className="login-button forgotpassword-button" disabled={isLoading}>
                  {isLoading ? (
                    <SpinLoading />
                  ) : (
                    "Enviar correo"
                  )}
                </Button>
              </Form>
            </Card.Body>
          </Card>
        )}
        {isOpen && !isPassword && (
          <Card className="login-card forgotpassword-card">
            <Card.Body style={{ padding: "0px" }}>
              <h2 className="login-title">Verifica tu identidad</h2>
              <p className="login-subtitle">Ingresa el código OTP de 4 dígitos enviado a tu correo.</p>
              {timeLeft === 0 && (
                <div className="login-alert" style={{ marginBottom: 16 }}>
                  <span className="icon" style={{ color: "#E53935" }}>i</span>
                  <div>El código OTP ha expirado</div>
                </div>
              )}
              <Form className="otp-verify-form">
                <ConfigProvider
                  theme={{
                    components: {
                      Input: {
                        activeBorderColor: "#EC6325",
                        activeBg: "#EAF0F5",
                      },
                    },
                  }}
                >
                  <div className={`otp-inputs ${otpError !== "" && timeLeft !== 0 ? "error" : ""}`}>
                    <Input.OTP variant="filled" length={4} onChange={onChange} disabled={timeLeft === 0} />
                  </div>
                  {otpError !== "" && timeLeft !== 0 && (
                    <p className="field-error" style={{ marginTop: "10px" }}>
                      {otpError}
                    </p>
                  )}
                </ConfigProvider>
                {timeLeft !== 0 && (
                  <span className="otp-verify-timer">00:{timeLeft < 10 ? `0${timeLeft}` : timeLeft}</span>
                )}
              </Form>
              <Button
                className="login-button forgotpassword-button"
                style={{ marginTop: "10px", marginBottom: "10px" }}
                onClick={() => submitOtp()}
                disabled={isLoading}
              >
                {isLoading ? (
                  <SpinLoading />
                ) : (
                  "Verificar"
                )}
              </Button>
              <p className="otp-verify-resend">
                ¿No recibiste el código? {" "}
                <a style={{ cursor: "pointer" }} onClick={() => resendOtp()}>
                  Reenvíar
                </a>
              </p>
            </Card.Body>
          </Card>
        )}
        {!isOpen && isPassword && (
          <Card className="login-card forgotpassword-card">
            <Card.Body style={{ padding: "0px" }}>
              <h2 className="login-title">Restablecer contraseña</h2>
              <p className="login-subtitle">Crea una nueva contraseña segura para tu cuenta.</p>
              <Form onSubmit={handleSubmit(onSubmitPassword)}>
                <Form.Group className="mb-4 position-relative">
                  <InputGroup className="login-input-group">
                    <Form.Control
                      type={showPassword ? "text" : "password"}
                      placeholder="Contraseña*"
                      {...register("password", {
                        required: "La contraseña es obligatoria",
                        minLength: { value: 8, message: "La contraseña debe tener al menos 8 caracteres" },
                        pattern: {
                          value: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,
                          message:
                            "La contraseña debe contener al menos 8 caracteres, \n1 letra mayúscula, \n1 letra minúscula, \n1 número, \n1 carácter especial",
                        },
                      })}
                      className="login-input-password"
                    />
                    <span onClick={() => setShowPassword(!showPassword)} className="login-eye">
                      <img src={showPassword ? EyeOff : Eye} alt="Mostrar/Ocultar contraseña" width={20} height={20} />
                    </span>
                  </InputGroup>
                  {errors.password && (
                    <div className="field-error">
                      {errors.password.message.split("\n").map((line, index) => (
                        <p key={index} className="mb-1">
                          {line}
                        </p>
                      ))}
                    </div>
                  )}
                </Form.Group>

                {/* Confirm Password Field */}
                <Form.Group className="mb-4 position-relative">
                  <InputGroup className="login-input-group">
                    <Form.Control
                      type={showConfirmPassword ? "text" : "password"}
                      placeholder="Confirmar contraseña*"
                      {...register("confirmPassword", {
                        required: "La confirmación de contraseña es obligatoria",
                        validate: (value) => value === watch("password") || "Las contraseñas no coinciden",
                      })}
                      className="login-input-password"
                    />
                    <span onClick={() => setShowConfirmPassword(!showConfirmPassword)} className="login-eye">
                      <img src={showConfirmPassword ? EyeOff : Eye} alt="EyeOff" />
                    </span>
                  </InputGroup>
                  {errors.confirmPassword && <p className="field-error">{errors.confirmPassword.message}</p>}
                </Form.Group>
                <Button type="submit" className="login-button forgotpassword-button" disabled={isLoading}>
                  {isLoading ? (
                    <SpinLoading />
                  ) : (
                    "Restablecer contraseña"
                  )}
                </Button>
              </Form>
            </Card.Body>
          </Card>
        )}
      </div>
    </>
  );
};

export default ForgotPassword;

